import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import useFetch from "../../../hook/useFetch";
import useHeaderRefresh from "../../../hook/useHeaderRefresh";

export default function RefundRequests() {
  const [requests, setRequests] = useState(null);
  const { get } = useFetch();

  const loadRequests = () => {
    get("/admin/payment/rollback-requests", null, null, setRequests);
  };
  useEffect(() => { loadRequests(); }, []);
  useHeaderRefresh(loadRequests);

  if (requests === null) {
    return <Skeleton count={12} />;
  }

  return (
    <div className="rso-pages card shadow bg-white rounded p-3 m-0">
      <h2>Refund requests</h2>
      {requests.length === 0 ? (
        <div className="alert alert-success mb-0">No pending refund requests.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered align-middle">
            <thead>
              <tr>
                <th>Requested</th>
                <th>User</th>
                <th>Order</th>
                <th>Product</th>
                <th>Amount</th>
                <th>Orders</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request.payment_id}>
                  <td>{request.refund_requested_at}</td>
                  <td>{request.username || request.email}</td>
                  <td>{request.order_number}</td>
                  <td>{request.product_title}</td>
                  <td>{request.amount} {request.currency}</td>
                  <td>{request.order_count}</td>
                  <td>
                    <Link className="btn btn-primary btn-sm" to={`/admin/users/${request.user_id}?order=${request.order_id}`}>
                      Review request
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
